/** Voice runtimes used by runtime selection, experiments, and telemetry. */
export enum VoiceAgentRuntime {
  Legacy = "legacy",
  SlowThinker = "slow_thinker",
}

/** Bounded Slow Thinker runtime failures persisted in traces and transfer audit metadata. */
export enum SlowThinkerRuntimeFailureType {
  SpeechPlaybackDidNotStart = "speech_playback_did_not_start",
  Unknown = "unknown",
}
